import { ChevronDown, X } from 'lucide-react';

import { Button } from '../../Button';
import { cn } from '../../utils';
import { type MultiselectRenderPropControls } from '../MultiselectInput.types';

/**
 * Two default icons that can be rendered for a `MultiselectInput`.
 *
 * The first icon is a `X` icon that is used to remove the selected options.
 * The second icon is a cosmetic `ChevronDown` synced with the popover `open` state.
 */
export const MultiselectInputDefaultIcons = <T,>({
  deselectOptions,
  selected,
  open,
}: MultiselectRenderPropControls<T>) => {
  return (
    <>
      <Button
        onClick={(e) => {
          deselectOptions(selected);
          e.stopPropagation();
        }}
        className={cn(
          'grid place-items-center rounded-full w-6 h-6 p-0 aspect-square group-hover:opacity-100 opacity-0',
        )}
        variant={'ghost'}
        color={'secondary'}
      >
        <X size={16} />
      </Button>
      <Button
        className={cn(
          'grid place-items-center rounded-full w-6 h-6 p-0 aspect-square',
        )}
        variant={'ghost'}
        color={'secondary'}
      >
        <ChevronDown size={16} className={cn(open && 'rotate-180')} />
      </Button>
    </>
  );
};
